import composeCheckboxesToBitwise from './composeCheckboxesToBitwise';
import composeCheckboxesToArray from './composeCheckboxesToArray';

const composeCheckboxesToBitwiseArray = values => ({
  values: composeCheckboxesToArray(values),
  formattedValue: composeCheckboxesToBitwise(values),
});

export default composeCheckboxesToBitwiseArray;
